import React from 'react'

function iOS() {
  return <div>iOS</div>
}

export default iOS
